import { render, staticRenderFns } from "./TagFilterContainer.vue?vue&type=template&id=1f3fbbcb&scoped=true"
import script from "./TagFilterContainer.vue?vue&type=script&lang=js"
export * from "./TagFilterContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3fbbcb",
  null
  
)

export default component.exports